import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ClientCalling from '../../api/ClientCalling';

const ClientCategoryList = ({ showRandom = false }) => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [displayCategories, setDisplayCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const resp = await ClientCalling?.getCategoryList();

            if (resp?.status && Array.isArray(resp.data)) {
                setCategories(resp.data);

                // Decide which categories to show
                if (showRandom && resp.data.length > 5) {
                    setDisplayCategories(shuffleArray(resp.data).slice(0, 5));
                } else {
                    setDisplayCategories(resp.data);
                }
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoading(false);
        }
    };

    // Shuffle function
    const shuffleArray = (array) => {
        return [...array].sort(() => Math.random() - 0.5);
    };

    const handleCategoryClick = (categoryId) => {
        navigate(`/category/${categoryId}`);
    };

    if (loading) {
        return (
            <div className="w-full py-1 md:py-4 flex justify-center">
                <style>{`
                    @keyframes shimmer {
                        0% { background-position: -1000px 0; }
                        100% { background-position: 1000px 0; }
                    }
                    .shimmer-effect {
                        animation: shimmer 2s infinite linear;
                        background: linear-gradient(to right, #2B1F37 0%, #443751 20%, #2B1F37 40%, #2B1F37 100%);
                        background-size: 1000px 100%;
                    }
                `}</style>
                <div className="flex flex-wrap justify-center gap-3">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="h-10 w-28 rounded-full shimmer-effect"></div>
                    ))}
                </div>
            </div>
        );
    }

    if (!displayCategories || displayCategories.length === 0) {
        return null;
    }

    return (
        <div className="w-full py-2 md:py-4 flex justify-center">
            <div className="flex flex-wrap justify-center gap-2 sm:gap-3 max-w-[1200px]">
                {displayCategories.map((category) => (
                    <button
                        key={category._id}
                        onClick={() => handleCategoryClick(category._id)}
                        className="ios-glass-btn px-3 sm:px-4 py-2 rounded-full
                flex items-center justify-center
                text-client-font text-sm sm:text-base font-medium
                cursor-pointer
                hover:scale-[1.04]
                focus:outline-none focus:ring-1 focus:ring-client-primary
                active:scale-95"
                    >
                        {category.category_name}
                    </button>
                ))}
            </div>
        </div>

    );
};

export default ClientCategoryList;
